import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Skeleton from '@mui/material/Skeleton'
import ConstrainedWrapper from './ConstrainedWrapper'

interface FormPageSkeletonProps {
  fields?: number
  maxWidth?: number
}

export default function FormPageSkeleton({
  fields = 6,
  maxWidth = 600,
}: FormPageSkeletonProps) {
  return (
    <Box sx={{ pb: 10 }} role="status" aria-label="Loading">
      <ConstrainedWrapper maxWidth={maxWidth}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            px: 2,
            pt: 4,
            pb: 1,
          }}
        >
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="text" width={160} height={28} />
        </Box>
      </ConstrainedWrapper>

      <ConstrainedWrapper maxWidth={maxWidth}>
        <Box sx={{ px: 2, pt: 1 }}>
          <Card sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {Array.from({ length: fields }).map((_, i) => (
                <Box key={i}>
                  <Skeleton
                    variant="text"
                    width={96}
                    height={16}
                    sx={{ mb: 0.5 }}
                  />
                  <Skeleton
                    variant="rounded"
                    height={56}
                    sx={{ borderRadius: '8px' }}
                  />
                </Box>
              ))}
              <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                <Skeleton
                  variant="rounded"
                  width={88}
                  height={40}
                  sx={{ borderRadius: '8px' }}
                />
                <Skeleton
                  variant="rounded"
                  width={88}
                  height={40}
                  sx={{ borderRadius: '8px' }}
                />
              </Box>
            </Box>
          </Card>
        </Box>
      </ConstrainedWrapper>
    </Box>
  )
}
